import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import moment from "moment";
import { FeriasEscolaresService } from "../../../services/FeriasEscolaresService";
import { FeriasService } from "../../../services/FeriasService";
import { numeroBmMixin } from "../../../mixins/numeroBmMixin";


export default {
  name: "DiscentesFérias",

  components: {
    FormDialog,
    SelectField,
    AutocompleteField,
    TextField,
    PeriodoField,
  },
  mixins:[numeroBmMixin],

  data: () => ({
    totalItems: 0,
    headers: [
      { text: "Nº BM", value: "numero", sortable: true },
      { text: "Posto/Graduação", value: "graduacao", sortable: true },
      { text: "Nome", value: "nome", sortable: true },
      { text: "Unidade/Lotação", value: "unidade", sortable: true },
      { text: "Exercício", value: "exercicio", sortable: true },
      { text: "Período", value: "periodo", sortable: true },
      { text: "Dias de Férias", value: "diasFerias", sortable: true },
      { text: "Dias Restantes", value: "diasRestantes", sortable: true },
      { text: "Status", value: "status", sortable: true },
      { text: "Parcela", value: "parcela", sortable: true },
      { text: "Abono", value: "status_abono", sortable: true },
    ],
    
    data: [],

    page: 1,
    unidade: null,
    pageCount: 0,
    itemsPerPage: 10,
    selected:[],
    disabledLotacao: true,
    optionsFilter: {
      postoGraduacao: [],
      status: [],
      unidadeLotacao: [],
      exercicio: [],
      lotacao: []
    },

    loading: {
      table: false,
      btn: false,
      field: false,
    },
    form: {},
    filter: {},
  
  }),

  beforeMount() {
    this.initializeFilter();
    this.getFerias();
  },
  mounted() {
    this.getFerias();
    this.getUnidadeItems();
    this.getGraduacaoItems();
    this.getExercicioItems();
  },

  watch: {
    page: function(val) {
      this.page = val;
      this.getFerias();
    },
    unidade: function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
        this.filter.lotacao = null;
      }
    }
  },

  methods: {
    initializeForm() {
      this.form = {
        perfil: "",
      };
    },

    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
      };
    },

    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.loading.field = false;
    },

    async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidadeLotacao = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidadeLotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    async getExercicioItems() {
      this.loading.field = true;
      const response = await FeriasEscolaresService.getExerciciosPesquisar();
      this.optionsFilter.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    async getGraduacaoItems() {
      this.loading.field = true;
      const response = await FeriasService.getGraduacao();
      this.optionsFilter.postoGraduacao = response.map((el) => {
        return {
          text: el.descricao,
          value: el.id,
        };
      });
      this.optionsFilter.postoGraduacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

    prepareFormFilter() {
      const filter = new FormData();
      filter.append("page", this.page);
      filter.append('aluno',true);
      filter.append('id_tipo',3);

      if (this.filter.numeroBM) {
        const numeroBM = this.filter.numeroBM.replace(".", "");
        const [numero, digitoVerificador] = numeroBM.split("-");
        filter.append("numero", this.removerZero(numero));
        if (digitoVerificador && digitoVerificador != undefined) {
          filter.append("digito_verificador", digitoVerificador);
        }
      }

      this.filter.nomeUsuario? filter.append("nome", this.filter.nomeUsuario) : null;
      this.filter.postoGraduacao? filter.append("id_graduacao", this.filter.postoGraduacao) : null;
      this.filter.status? filter.append("status", this.filter.status) : null;
      this.filter.dataInicio? filter.append( "data_ini",moment(this.filter.dataInicio).format("YYYY-MM-DD")) : null;
      this.filter.dataFim? filter.append("data_fin",moment(this.filter.dataFim).format("YYYY-MM-DD") ) : null;
      this.unidade? filter.append("id_unidade", this.unidade): null;
      this.filter.lotacao? filter.append("id_lotacao", this.filter.lotacao): null;
      this.filter.exercicio? filter.append("exercicio", this.filter.exercicio): null;

      return filter;
    },

    async getFerias() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await FeriasService.obterFerias(filter);
      this.data =  response.data;
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
    },

  },
};